import React, { Component } from 'react';
import { Container, Header, Item, Segment } from 'semantic-ui-react';
import{Link} from "react-router-dom";


class SingleStoryCard extends Component {

    render() {        
        return (
            <div style={{marginTop: "2em", marginBottom: "2em"}}>
                <Header as='h2'>{this.props.title}</Header>
                <p>{this.props.description}</p>
                <Container text>
                    <Link to={'/play/'+this.props.item.id} style={{cursor: 'pointer'}}>
                        <Segment style={{}}>
                            <Item.Group>
                                <Item>
                                    <Item.Image size='medium' src={this.props.item.cover} />

                                    <Item.Content>
                                        <Item.Header>{this.props.item.title}</Item.Header>
                                        <Item.Meta>von {this.props.item.authorName.firstName}</Item.Meta>
                                        <Item.Meta>gesprochen von {this.props.item.speakerName.firstName}</Item.Meta>
                                        <Item.Meta>{truncate(this.props.item.description, 600)}</Item.Meta>
                                    </Item.Content>
                                </Item>
                            </Item.Group>
                        </Segment>
                    </Link>
                    
                </Container>
            </div>
        );
    }
}

const truncate = (str, n) => {
    return (str.length > n) ? str.substr(0, n-1) + '...' : str;
};

export default SingleStoryCard;



// WEBPACK FOOTER //
// ./src/components/PageComponents/SingleStoryCard.js